import { Navigate } from 'react-router';
import React from 'react';


const ProtectedRoute = ({ user, children }) => {
    if (!user) {
        return <Navigate to="/login" />;
    }

    return <>{children}</>;
};
export default ProtectedRoute;
